// extracted by mini-css-extract-plugin
module.exports = {"heading":"EditMetaverseAnalyticsPage_heading__vkqz9","metrics":"EditMetaverseAnalyticsPage_metrics__1kBqg","table":"EditMetaverseAnalyticsPage_table__2aDzZ"};